export const TopUpIntentType = {
  None: "none",
  SetupIntent: "setupIntent",
  PaymentIntent: "paymentIntent",
} as const;

export type TopUpIntentType = typeof TopUpIntentType[keyof typeof TopUpIntentType];

export enum UserIntentAction {
  TopUp = 0,
  AddCard = 1,
}

export enum PaymentType {
  InitialPayment = 0,
  AutoTopUp = 1,
  ManualTopUp = 2,
  FreeTopUp = 3,
}

export const TopUpConfirmationStatus = {
  pending:  "pending",
  success: "success", 
  failed: "failed"
}